<template>
  <v-card
    :outlined="outlined"
    :min-width="`${minWidth}px`"
    :width="width"
    :class="`ma-${margin}`"
    class="d-flex flex-column"
    :loading="loading"
    :elevation="0"
  >
    <v-card-title
      v-if="!hideTitle"
      class="title text-truncate"
      :class="gradientStyle ? 'white--text' : ''"
      :style="gradientStyle"
      style="min-height: 68px"
    >
      <v-icon left v-if="icon">{{ icon }}</v-icon>

      <slot name="header"></slot>

      {{ title }}

      <v-spacer />
      <slot name="actions" />
    </v-card-title>
    <v-card-subtitle v-if="subtitle && !hideTitle" :style="gradientStyle" v-html="subtitle" />
    <v-card-subtitle v-else-if="!hideTitle && $slots['subtitle']">
      <slot name="subtitle"></slot>
    </v-card-subtitle>

    <v-row align="center" class="ma-1" v-if="subtitle && hideTitle">
      <v-card-subtitle v-if="subtitle" :style="gradientStyle">
        {{ subtitle }}
      </v-card-subtitle>
      <v-spacer />
      <slot v-if="hideTitle" name="actions" />
    </v-row>

    <v-card-text :style="fullscreen ? '' : `max-height: ${height}`" :class="slotClass" class="pt-1">
      <slot name="main" />
      <slot></slot>
    </v-card-text>

    <v-card-actions class="px-6" @mouseenter="onActionHover(true)" @mouseleave="onActionHover(false)">
      <slot name="card-actions" />
    </v-card-actions>
  </v-card>
</template>

<script lang="ts">
import { PartnerColor } from "@/lib/partnerColor";
import DarkModeHighlightMixin from "@/mixins/DarkModeHighlightMixin.vue";
import { Component, Prop } from "vue-property-decorator";

@Component({
  components: {}
})
export default class Card extends DarkModeHighlightMixin {
  @Prop()
  icon?: string;

  @Prop()
  title?: string;

  @Prop({ default: false })
  hideTitle?: string;

  @Prop()
  subtitle?: string;

  @Prop({ default: true })
  outlined?: boolean;

  @Prop({ default: false })
  hideDivider?: boolean;

  @Prop({ default: 2 })
  margin?: number;

  @Prop({ default: 250 })
  minWidth?: number;

  @Prop()
  width?: string;

  @Prop()
  height?: number;

  @Prop({ default: "" })
  slotClass!: string;

  @Prop({ default: false })
  showGradient?: boolean;

  @Prop({ default: false })
  loading?: boolean;

  @Prop()
  fullscreen?: boolean;

  partnerColor = new PartnerColor();

  get gradientStyle() {
    if (this.showGradient) {
      return this.partnerColor.gradientStyle;
    }
    return "";
  }

  onActionHover(isHovered: boolean) {
    this.$emit("hover:action", isHovered);
  }
}
</script>

<style></style>
